module.exports = __webpack_public_path__ + "img/path.01acfeb9.svg";